import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { CustomInputFileComponent } from '../../../components/custom-input-file/custom-input-file.component';
import { ExceptionComponent } from '../../../components/exception/exception.component';
import { AuthService } from '../../../services/auth/auth.service';


@Component({
  selector: 'app-exceptions-create',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, ImageSectionHeadComponent, CustomInputFileComponent, ExceptionComponent],
  templateUrl: './exceptions-create.component.html',
  styleUrl: './exceptions-create.component.scss'
})
export class ExceptionsCreateComponent {
  title = $localize`:@@Router.Exceptions.New:Nueva autorización`;
  description = "";
  image = "assets/images/teclado.jpg";

  applicantId: string = '';
  selectedVehicle: string | null = null;
  autType: string | null = null;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthService
  ) {
    this.applicantId = this.authService.getCurrentUser().documentNumber;
    this.autType = this.activeRoute.snapshot.paramMap.get('code') || null;
    this.selectedVehicle = this.activeRoute.snapshot.paramMap.get('plate') || null;
    if (this.autType == 'multiple') {
      this.selectedVehicle = null;
      this.title = $localize`:@@Router.Exceptions.NewMultiple:Autorizaciones para flotas`;
    }
  }

  goBack() {
    this.router.navigate(['/vehicles']);
  }
}
